import { captureException } from '@sentry/vue';

import { log } from '@libs/utils';

import { getErrorMessage } from './errorMessage';

export function logException(
  error: unknown,
  value?: Record<string, unknown>
): void;
export function logException(
  message: string,
  value?: Record<string, unknown>
): void;
export function logException(
  errorOrMessage: unknown,
  value?: Record<string, unknown>
): void {
  log({ title: 'Exception', context: [errorOrMessage, value], level: 'error' });

  if (import.meta.env.MODE !== 'development') {
    const errorMsg = getErrorMessage(errorOrMessage);

    captureException(new Error(errorMsg), {
      extra: {
        value,
      },
    });
  }
}
